import { Link, useLocation } from "react-router-dom";
import { Layers3, Music4, SlidersVertical } from "lucide-react";

/** Song · Parts · Mix Desk — the three rooms of one song's studio. */
export default function SongStudioTabs({ songId }) {
  const { pathname } = useLocation();
  const tabs = [
    { key: "song", label: "Song", icon: Music4, to: `/create/song/${songId}` },
    { key: "parts", label: "Parts", icon: Layers3, to: `/create/song/${songId}/stems` },
    { key: "mix", label: "Mix Desk", icon: SlidersVertical, to: `/create/song/${songId}/mix` },
  ];
  return (
    <nav aria-label="Song studio" data-testid="song-studio-tabs" className="inline-flex rounded-full border border-white/10 bg-black/30 p-1">
      {tabs.map((t) => {
        const active = pathname === t.to;
        const Icon = t.icon;
        return (
          <Link key={t.key} to={t.to} data-testid={`song-tab-${t.key}`} aria-current={active ? "page" : undefined}
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-[0.14em] transition-colors duration-200 ${active ? "bg-white text-[#05070f]" : "text-white/65 hover:text-white"}`}>
            <Icon className="h-3.5 w-3.5" /> {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
